import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NextImage as SitecoreNextImage, Link as SitecoreLink, RichText as SitecoreRichText } from '@sitecore-content-sdk/nextjs';
const PromoDefaultComponent = (props)=>/*#__PURE__*/ _jsx("div", {
        className: `component promo ${props?.params?.styles}`,
        children: /*#__PURE__*/ _jsx("div", {
            className: "component-content",
            children: /*#__PURE__*/ _jsx("span", {
                className: "is-empty-hint",
                children: "Promo"
            })
        })
    });
export const Default = (props)=>{
    const id = props.params.RenderingIdentifier;
    if (props.fields) {
        return /*#__PURE__*/ _jsx("div", {
            className: `component promo ${props?.params?.styles}`,
            id: id ? id : undefined,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "component-content",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "field-promoicon",
                        children: /*#__PURE__*/ _jsx(SitecoreNextImage, {
                            field: props.fields.PromoIcon
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "promo-text",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "field-promotext",
                                    children: /*#__PURE__*/ _jsx(SitecoreRichText, {
                                        field: props.fields.PromoText
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "field-promolink",
                                children: /*#__PURE__*/ _jsx(SitecoreLink, {
                                    field: props.fields.PromoLink
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ _jsx(PromoDefaultComponent, {
        ...props
    });
};
export const WithText = (props)=>{
    const id = props.params.RenderingIdentifier;
    if (props.fields) {
        return /*#__PURE__*/ _jsx("div", {
            className: `component promo ${props?.params?.styles}`,
            id: id ? id : undefined,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "component-content",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "field-promoicon",
                        children: /*#__PURE__*/ _jsx(SitecoreNextImage, {
                            field: props.fields.PromoIcon
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "promo-text",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "field-promotext",
                                    children: /*#__PURE__*/ _jsx(SitecoreRichText, {
                                        className: "promo-text",
                                        field: props.fields.PromoText
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "field-promotext",
                                children: /*#__PURE__*/ _jsx(SitecoreRichText, {
                                    className: "promo-text",
                                    field: props.fields.PromoText2
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ _jsx(PromoDefaultComponent, {
        ...props
    });
};
